module.exports = __webpack_public_path__ + "static/media/om_beard_stubble_round_blonde.80372330.png";